export const PieChartColors = [
  "#00af3f",
  "#cf366d",
];

const getColor = index => PieChartColors[index % PieChartColors.length];

export default getColor;
